module.exports = __webpack_public_path__ + "static/media/R11.9650c306.jpg";